module.exports = __webpack_public_path__ + "static/media/aboutbg.32eccb7b.jpg";